import { DateUtils } from "~app/common/utils/date-utils";

export class LeverantorsorderViewModel {
    constructor(private readonly model: any) {
    }

    get id() {
        return this.model.id;
    }

    get leverantor() {
        return this.model.leverantor;
    }

    get leverantorHk() {
        return this.model.leverantorHk;
    }

    get leverantorInternr() {
        return this.model.leverantorInternr;
    }

    get ordernr() {
        return this.model.ordernr;
    }

    get periodFrom() {
        return DateUtils.shortDateString(this.model.periodFrom);
    }

    get periodTom() {
        return DateUtils.shortDateString(this.model.periodTom);
    }

    get status() {
        return this.model.status;
    }

    get handelssortimentsgrupp() {
        return this.model.handelssortimentsgrupp;
    }

    get avtalsansvarig() {
        return this.model.avtalsansvarig;
    }
}
